import { setDefaultAssets } from '@leagueplatform/asset-config';
import { HIGHMARK_COMMON_ASSETS_MAP } from './asset-map';

export const initModule = () => {
  setDefaultAssets(HIGHMARK_COMMON_ASSETS_MAP);
};
